import {Table} from "antd";
import React, {useState} from "react";
import {useColumns} from "./UseColumns";
import {createUseStyles} from "react-jss";
import {useGetCategories} from "../../hooks/UseGetCategories";
import CategoryCreateButton from "./create/CategoryCreateButton";
import CategoryPicture from "./CategoryPicture";
import {useGetSelfEmployeeQuery} from "../../store/api/EmployeeApi";
import ErrorAccessDenied from "../../components/error/ErrorAccessDenied";

const useStyles = createUseStyles<string>({
    button: {
        marginBottom: "1rem",
        marginLeft: "8px",
        marginRight: "8px"
    },
    table: {
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "5px 10px 24px 5px rgb(232, 232, 232)"
    }
})

interface PictureData {
    pictureUrl: string | undefined
}

const CategoryTable = () => {

    const classes = useStyles()
    const {data: employee} = useGetSelfEmployeeQuery()
    const {categories, onChangeTable, loading, filter, total} = useGetCategories()
    const [visible, setVisible] = useState(false)
    const [pictureData, setPictureData] = useState<PictureData>({pictureUrl: ''})

    const showPicture = (pictureUrl: string | undefined) => {
        setPictureData({pictureUrl})
        setVisible(true)
    }

    const columns = useColumns({showPicture})

    return (
        <>
            <div className={classes.button}>
                {employee?.data?.permission.canCreateCategory && <CategoryCreateButton/>}
            </div>
            {employee?.data?.permission.canReadCategories ?
                <>
                    <Table
                        className={classes.table}
                        components={{body: {cell: undefined}}}
                        bordered
                        columns={columns}
                        loading={loading}
                        rowKey={row => row.id}
                        scroll={{x: 1400}}
                        onChange={onChangeTable}
                        dataSource={categories}
                        pagination={{pageSize: filter.size, current: filter.page, total: total}}
                    />
                    <CategoryPicture pictureUrl={pictureData.pictureUrl} visible={visible} setVisible={setVisible}/>
                </>
                : <ErrorAccessDenied/>}
        </>
    )

}

export default CategoryTable